// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"861":"a95d9d16","958":"4a3d1b9a"}[chunkId] + ".chunk.js";
};